import { Button, Col, Row, Tabs, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
// import { Link, useHistory } from 'react-router-dom'
// import CampignIntroComponent from '../../components/Brand/CampignIntroComponent'
// import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent'
// import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent'
// import CreditDetailsComponent from '../../components/Brand/Credit/CreditDetailsComponent';
import { useGlobalState } from '../../../../store/state';
import AdminChatsListComponent from './AdminChatsListComponent';
// import AdminChatsListComponent from './AdminChatsListComponent'
import AdminChatBoxComponent from './AdminChatBoxComponent';
// import ChatBox from 'react-custom-chat'
import AdminBrandChatBoxComponent from './AdminBrandChatBoxComponent';

import './AdminChatHolder.styles.scss';

const { TabPane } = Tabs;
export const AdminChatHolder = () => {
  const [user] = useGlobalState('user');
  const [activeChat, setActiveChat] = useState(null);


  const activeChatSetting = (_obj) =>{
    console.log('active chat Ob', _obj);
    setActiveChat(_obj);
  };


  const [messageList, setMessageList] = useState([
    { text: 'hello', person: 'primary' },
  ]);

  const handleSendMessage = (newMessage) => {
    setMessageList([
      ...messageList,
      { text: newMessage, person: 'primary' },
    ]);
  };
  return (
    <div className="chat_holder admin_chats">
      <Tabs tabPosition="left"
        type="card">
        <TabPane tab="Influencers"
          key="1">
          <Row gutter={16}
            className="chat_holder_row">
            <Col span={10}>
              <AdminChatsListComponent getActiveChat={activeChatSetting}/>
            </Col>
            <Col span={14}>
              <AdminChatBoxComponent activeChat={activeChat}/>
            </Col>
          </Row>
        </TabPane>
        <TabPane tab="Brand"
          key="2">
                    Content of Tab 2
          {/* <BrandChatBoxComponent activeChat={activeChat}/>  */}
          <AdminBrandChatBoxComponent activeChat={activeChat}/>
        </TabPane>
      </Tabs>
      {/* <Row gutter={16} className="chat_holder_row">
                <Col span={4}>

                </Col>
                <Col span={10}>


                </Col>
                <Col span={14}>
                </Col>
            </Row> */}
    </div>
  );
};
